import React from 'react'
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

const styleCard ={
    borderRadius: '1rem'
}

const EmailQuerter = () => {
  return (<>
        <Card style={styleCard}>
            <CardBody>
                <CardTitle>Monthly Tracking</CardTitle>
                <div className="feed-widget">
                    <ul className="list-style-none feed-body m-0 pb-3">
                        <li className="feed-item">
                            <div className="feed-icon bg-info"><i className="far fa-bell"></i></div> 1245 Email sent by Dhaval Gohel
                        </li>
                        <li className="feed-item">
                            <div className="feed-icon bg-success"><i className="ti-server"></i></div> 1345 Email sent by Prachi Patel
                        </li>
                        <li className="feed-item">
                            <div className="feed-icon bg-warning"><i className="ti-shopping-cart"></i></div> 1445 Email sent by Hiten Jaypal
                        </li>
                        <li className="feed-item">
                            <div className="feed-icon bg-danger"><i className="ti-user"></i></div> 1567 Email sent by Hitanshi Shah
                        </li>
                    </ul>
                </div>
            </CardBody>
        </Card>
    </>);
}

export default EmailQuerter